import { createFileRoute } from "@tanstack/react-router";

import CreateGameSessionPage from "~/pages/gameSession/CreateGameSessionPage.tsx";

export const Route = createFileRoute("/_auth/game-session/")({
    component: CreateGameSessionPage,
});
